import { RootStateOrAny } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { getPromoCode } from 'selectors/basket'
import { getPromoBannerCode, getIsSignupReductionEnabled } from 'selectors/features'

import { PROMO_CODE_DATA } from './homeConfig'

export const getPromoBannerState = (state: RootStateOrAny) => {
  const isSignupReductionEnabled = getIsSignupReductionEnabled(state)
  const currentPromo = state.promoCurrent || ''
  const basketPromo = getPromoCode(state) || ''
  const isAuthenticated = state.auth.get('isAuthenticated')
  const promoCode = getPromoBannerCode(state) || PROMO_CODE_DATA.defaultPromoCode

  const hasBasketPromo = basketPromo.length > 0
  const hasCurrentPromo = currentPromo.length > 0

  const hasError =
    !!state.error.get(actionTypes.PROMO_GET) || !!state.error.get(actionTypes.PROMO_APPLY)

  const hide =
    isAuthenticated || hasError || hasBasketPromo || hasCurrentPromo || isSignupReductionEnabled

  const canApplyPromo = !hide

  return {
    promoCode,
    canApplyPromo,
    basketPromo,
  }
}
